"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
//
// assets
//
const accountCopy_1 = require("../../../../copy/accountCopy");
//
// components
//
const BillingTabLink_1 = __importDefault(require("../BillingTabLink"));
//
// styles
//
const StyledContainer_1 = require("./StyledContainer");
const StyledLink_1 = require("./StyledLink");
const StyledListItem_1 = require("./StyledListItem");
const AccountNavigation = () => {
    return (react_1.default.createElement(StyledContainer_1.StyledContainer, { className: 'settings-nav' },
        react_1.default.createElement(StyledListItem_1.StyledListItem, { className: 'nav-item' },
            react_1.default.createElement(StyledLink_1.StyledLink, { className: 'nav-link account-link', role: 'link', to: '/account/overview' }, accountCopy_1.accountCopy.tab1)),
        react_1.default.createElement(StyledListItem_1.StyledListItem, { className: 'nav-item' },
            react_1.default.createElement(StyledLink_1.StyledLink, { className: 'nav-link account-link', role: 'link', to: '/account/developer' }, accountCopy_1.accountCopy.developerTab)),
        react_1.default.createElement(StyledListItem_1.StyledListItem, { className: 'nav-item' },
            react_1.default.createElement(BillingTabLink_1.default, { className: 'nav-link billing-link' }))));
};
exports.default = AccountNavigation;
